let btnCountdown = {
  inserted (el, binding) {
    let timer;
    let flag = true;
    let name = el.innerHTML;
    let bg = el.style.backgroundColor;
    let { fun, num = 9 } = binding.value;//获取参数
    el.addEventListener('click', () => {
      if (flag) {
        el.innerHTML = '<i class="el-icon-loading"></i><span>导出中</span>'
        flag = false;
        fun().then((res) => {
          el.innerHTML = num + 's后导出';
          el.style.backgroundColor = "#DBDBDB";
          el.style.border = "#DBDBDB";
          el.style.color = "#fff"
          if (!timer) {
            let time = num - 1;
            timer = setInterval(function () {
              el.innerHTML = time + "s后导出";
              if (time == 0) {
                flag = true;
                el.removeAttribute('style');
                el.blur();
                el.innerHTML = name;
                clearInterval(timer);
                timer = null;
              }
              time--;
            }, 1000);
          }
        })
      }

    })
  }
}
export default btnCountdown



// WEBPACK FOOTER //
// ./src/directives/src/btnCountdown.js